import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyC2t-DvJGgb2NSbRYLGUkYl4GCzo27_Tjg',
  authDomain: 'mealwell-7440e.firebaseapp.com',
  projectId: 'mealwell-7440e',
  storageBucket: 'mealwell-7440e.firebasestorage.app',
  messagingSenderId: '351782438227',
  appId: '1:351782438227:web:d08f8dc38e113882db0da6',
  measurementId: 'G-0L0F1LW2QL',
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider };